<template>
  <!-- 商品详情页 -->
  <div class="product-detail" v-if="detailList">
    <!-- 引入公共头部 -->
    <dg-header :showBack="true" title="商品详情" ></dg-header>
    <!-- banner轮播部分 -->
    <detail-banner :detailList="detailList"></detail-banner>
    <div class="section">
      <!-- banner下商品信息 -->
      <goods-info :detailList="detailList" :price="price"></goods-info>
      <!-- 详情内容 -->
      <detail-content :detailList="detailList"  ref="content"></detail-content>
    </div>

    <!-- 底部加入购物车商品导航 -->
    <detail-action @showPopup="showPopup" ref="footerCarNav" :detailList="detailList"></detail-action>
    <!-- 点击加入购物车出现弹框 -->
    <car-popup :detailList="detailList" :price="price"  ref="showPopup" :type="type"></car-popup>
  </div>
</template>
<script>
import DgHeader from '@/components/header'
import DetailBanner from './components/banner'
import GoodsInfo from './components/goods-info'
import DetailContent from './components/content'
import DetailAction from './components/good-action'
import CarPopup from '@/components/cart-popup'
import api from '@/server'
export default {
  data () {
    return {
      detailList: [],
      exchange: {},
      type: '',
      // 根据商品ID请求数据
      params: {
        id: this.$route.query.id
      },
      // 参考价格 usd美元 rmb人民币
      price: {
        usd: '',
        rmb: '',
        gbp: ''
      },
    }
  },
  components: {
    DgHeader,
    DetailBanner,
    GoodsInfo,
    DetailContent,
    DetailAction,
    CarPopup
  },
  created () {
    // 请求商品详情信息
    api.detailData(this.params).then(res => {
      if(res.code === 200 && res.data.resullt){
        this.detailList = res.data.resullt[0];
        this.exchange = res.data.exchRateList[0];
        let price;
        price = this.detailList.groupBuy.groupBuyComm ?
                this.detailList.groupBuy.groupBuyPrice:
                this.detailList.price;
        this.price.rmb = Math.ceil(price / this.exchange.rmb);
        this.price.usd = Math.ceil(price / this.exchange.usd);
        this.price.gbp = Math.ceil(price / this.exchange.gbp);
      }else{
        this.detailList = [];
      }
    }).catch(err =>{
      console.log(err)
    })
  },
  methods: {
    // 从good-action子组件传出来的点击加入购物车出现弹框
    showPopup(type){
      if(type === 'jumpCar') {
        this.type = 'add'
      } else if(type === 'jumpConfirmOrder') {
        this.type = 'buy'
      } else {
        this.type = 'group'
      }
      this.$refs.showPopup.open();
    },
  }
}
</script>
<style lang="scss" scoped>
.product-detail{
  padding: 88px 0 100px;
  .header-wrap{
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .section{
    padding: 30px;
  }
}

</style>

